var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"fd-button",class:[_vm.config.color, { selected: _vm.selected }]},_vm.$listeners),[(_vm.config.icon)?_c('i',{class:_vm.config.icon}):_vm._e(),_vm._v("\n\t"+_vm._s(_vm.config.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }